import React from 'react';
import COLORS from 'src/lib/colors';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
  DialogContent,
  makeStyles,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles({
  paper: { borderRadius: '1rem', margin: '1rem' },
  titleWrapper: {
    padding: '0',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: '1rem',
    fontWeight: 500,
    letterSpacing: '-0.5pt',
    alignSelf: 'center',
    marginTop: '-1.6rem',
    marginBottom: '-.5rem',
  },
  titlePadding: { marginTop: '2rem' },
  dialogContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  closeIcon: {
    justifyContent: 'flex-end',
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  dialogContentText: {
    color: COLORS.secondaryNeutralCharcoal,
    textAlign: 'center',
    marginTop: '1rem',
    letterSpacing: '-0.5pt',
    lineHeight: '1.2rem',
  },
  actionsWrapper: {
    flexDirection: 'column',
  },
  primaryButton: {
    width: '90%',
    margin: '11px 0 13px 0',
    height: '2.5rem',
    borderRadius: '1.885rem',
    background: COLORS.brandRed,
    color: COLORS.whiteSmoke,
    textTransform: 'none',
    fontSize: '1rem',
  },
  secondaryButton: {
    width: '90%',
    margin: '13px 0 31px 0',
    height: '2.5rem',
    border: 'none',
    background: `${COLORS.primaryWhite} !important`,
    color: COLORS.brandCyan,
    textTransform: 'none',
    fontSize: '1rem',
    boxShadow: 'none !important',
    '&:hover': {
        backgroundColor: 'none',
      },
  },
  vericalGap: {
    width: '100%',
    height: '.2rem',
  },
});

export type DonationReportDialogProps = {
  open: boolean;
  onClose: () => void;
  reportFraud: (e:any) => void;
};

export default function DonationReportDialog(props: DonationReportDialogProps) {
  const {
    open,
    onClose,
    reportFraud,
  } = props;
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="donation-report-dialog-title"
      classes={{
        paper: classes.paper,
      }}
    >
      <DialogTitle
        disableTypography
        id="list-create-edit-dialog-title"
        className={classes.titleWrapper}
      >
        <Button
          fullWidth
          onClick={onClose}
          className={classes.closeIcon}
          id="close-button"
        >
          <img src={require('../../assets/icons/iconCloseBlack.svg')} alt="close icon" />
        </Button>
        <Typography
          className={classes.title}
          id="list-create-edit-dialog-title-text"
        >
          Report
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContentWrapper}>
          <DialogContentText className={classes.dialogContentText}>
            I don't recognize this educator and believe <br />this may be a fraudulent account.
          </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actionsWrapper}>        
          <Button
            variant="contained"
            onClick={reportFraud}
            classes={{
              root: classes.primaryButton,
            }}
          >
            Report
          </Button>         
          <Button
            variant="contained"
            onClick={onClose}
            classes={{
              root: classes.secondaryButton,
            }}
          >
            Cancel
          </Button>
      </DialogActions>
    </Dialog>
  );
}